import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from './auth.service';

// Routes HR can reach even though they're otherwise scoped to Hiring Compass —
// notifications and account (profile/settings) are personal to the user, not
// part of the project/board surface HR shouldn't see.
const HR_ALLOWED_PREFIXES = ['/hiring', '/inbox', '/account'];

export function hrScopeGuard(): CanActivateFn {
  return (route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    return auth.ensureCurrentUser().pipe(
      map((user) => {
        if (user?.systemRole === 'HR' && !HR_ALLOWED_PREFIXES.some(p => state.url.startsWith(p))) {
          return router.createUrlTree(['/hiring']);
        }
        return true;
      }),
    );
  };
}
